"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ui_1 = require("@rahtab/ui");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const Header = ({ children, style }) => {
    const { top: paddingTop } = react_native_safe_area_context_1.useSafeAreaInsets();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_1.StatusBar, { barStyle: "dark-content", backgroundColor: 'rgba(0,0,0,0)', translucent: true }),
        react_1.default.createElement(react_native_1.ImageBackground, { source: require('../assets/header-pattern-bg.png'), imageStyle: { resizeMode: 'cover', height: 110, opacity: 0.5 }, style: react_native_1.StyleSheet.flatten([styles.header, { paddingTop: paddingTop + ui_1.getSpacing(2) }, style]) }, children)));
};
exports.default = Header;
const styles = react_native_1.StyleSheet.create({
    header: {
        backgroundColor: ui_1.Colors.white,
        resizeMode: 'cover',
        padding: ui_1.getSpacing(),
        // paddingTop: getSpacing(3),
        overflow: 'hidden',
        position: 'relative',
        ...ui_1.getShadow(),
        ...react_native_1.Platform.select({
            web: {
                touchAction: 'none',
                overscrollBehaviorY: 'contain',
            },
        }),
    },
});
